import { DecimalRange } from '@bpd-library/utilities';

/*
    Checks if rangeA is within range of rangeB
*/
const isRangeWithinRange = (rangeA: DecimalRange, rangeB: DecimalRange): boolean => {
    let moreThanMin = true;
    let lessThanMax = true;

    if (!rangeA.from && !rangeA.to) return false;

    if (rangeA.from) {
        if (rangeB.to) {
            if (rangeB.to < rangeA.from) moreThanMin = false;
        } else if (rangeB.from) {
            if (rangeB.from < rangeA.from) moreThanMin = false;
        }
    }

    if (rangeA.to) {
        if (rangeB.from) {
            if (rangeB.from > rangeA.to) lessThanMax = false;
        } else if (rangeB.to) {
            if (rangeB.to > rangeA.to) lessThanMax = false;
        }
    }

    return moreThanMin && lessThanMax;
};

export default isRangeWithinRange;
